import { usePathname } from 'next/navigation';
import { useCallback, useEffect, useRef, useState } from 'react';

const MIN_SCROLL_DOWN = 64;
const MIN_SCROLL_UP = 64;

export default function useHideNavbar() {
  const [visible, setVisible] = useState(true);
  const prevScrollPos = useRef(0);
  const pathname = usePathname();

  const handleScroll = useCallback(() => {
    const currentScrollPos = window.scrollY;

    if (currentScrollPos === 0) {
      setVisible(true);
    }

    if (
      currentScrollPos < MIN_SCROLL_DOWN ||
      prevScrollPos.current - currentScrollPos > MIN_SCROLL_UP
    ) {
      setVisible(true);
    } else if (currentScrollPos > prevScrollPos.current) {
      setVisible(false);
    }

    prevScrollPos.current = currentScrollPos;
  }, []);

  const throttledHandleScroll = useCallback(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    return () => {
      if (timeoutId === null) {
        timeoutId = setTimeout(() => {
          handleScroll();
          timeoutId = null;
        }, 100);
      }
    };
  }, [handleScroll]);

  useEffect(() => {
    prevScrollPos.current = window.scrollY;

    setVisible(true);

    const throttled = throttledHandleScroll();
    window.addEventListener('scroll', throttled);

    return () => window.removeEventListener('scroll', throttled);
  }, [throttledHandleScroll]);

  useEffect(() => {
    handleScroll();
  }, [handleScroll, pathname]);

  return visible;
}
